const LOGO_URL = "https://customer-assets.emergentagent.com/job_custom-crm-sites/artifacts/8izxjzv1_BBA16439-7801-4AC0-89CE-C05F76F41FC7.jpeg";

/**
 * Full horizontal Shumway Tech lockup (mark + wordmark + circuit traces).
 * Rendered as a single image — no separate text or container needed.
 *
 * Sized by HEIGHT; width auto-scales to keep the lockup's aspect ratio.
 */
export default function Logo({ height = 44 }) {
  return (
    <img
      src={LOGO_URL}
      alt="Shumway Tech"
      style={{ height, width: "auto", display: "block" }}
      data-testid="brand-logo"
    />
  );
}

export { LOGO_URL };
